import React from 'react';
import Grid from '@material-ui/core/Grid';

import OnboardingCard from '../components/Onboarding/OnboardingCard';
import SupportRow from '../components/Onboarding/SupportRow';

export default function Onboarding({ cards, header, subheader1, subheader2 }) {
  const cardsComponents = cards.map((card, index) => {
    // eslint-disable-next-line no-param-reassign
    card.step = index + 1;
    return <OnboardingCard key={card.id} card={card} />;
  });

  return (
    <div className="onboarding-page">
      <div className="row header-block">
        <div className="col-8 offset-2">
          <p className="page-header">{header}</p>
          <p className="page-subheader1">{subheader1}</p>
          <p className="page-subheader2">{subheader2}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Grid container spacing={4}>{cardsComponents}</Grid>
        </div>
      </div>
      <SupportRow />
    </div>
  );
}
